// REUNIÃO GERAL (2026-09-03) — utilitários da tela da pauta de sexta.
// Mesmo padrão do módulo da Weekly (operacional-reunioes/utils.ts): getToken do
// Cognito, `un()` para desembrulhar o proxy do API Gateway, e uma função `api()`
// que fala com POST /comercial/propostas-geradas.

import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';
import dayjs, { Dayjs } from 'dayjs';
import { API_URL } from '../../config';

export async function getToken(): Promise<string> {
  const session = await fetchAuthSession();
  return session.tokens?.idToken?.toString() ?? '';
}

// Desembrulha a resposta do proxy do API Gateway (padrão da casa).
export function un(r: { data: any } | null | undefined): any {
  return r?.data?.body ? JSON.parse(r.data.body) : r?.data;
}

// `Authorization: <idToken>` — sem o prefixo "Bearer", como no resto do sistema.
// timeoutMs só para as ações que chamam a IA (gerar a pauta): 120000.
export async function api(
  action: string,
  extra: Record<string, any> = {},
  timeoutMs?: number,
): Promise<any> {
  const token = await getToken();
  const r = await axios.post(`${API_URL}/comercial/propostas-geradas`,
    { action, ...extra },
    { headers: { Authorization: token }, ...(timeoutMs ? { timeout: timeoutMs } : {}) });
  return un(r);
}

export function erroMsg(e: any): string {
  return e?.response?.data?.error || e?.message || 'erro desconhecido';
}

// DATE do backend chega como ISO UTC meia-noite: fatiar o yyyy-mm-dd ANTES de
// formatar, senão em BRT (UTC-3) cai no dia anterior.
export function isoDia(v: string | null | undefined): string {
  return v ? String(v).slice(0, 10) : '';
}

export function fmtData(v: string | null | undefined): string {
  const s = isoDia(v);
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : '—';
}

export function fmtDataHora(v: string | null | undefined): string {
  if (!v) return '—';
  const d = dayjs(v);
  return d.isValid() ? d.format('DD/MM/YYYY HH:mm') : '—';
}

// Segunda-feira da semana de uma data (0=Dom..6=Sáb).
export function segundaDe(d: Dayjs): Dayjs {
  const dow = d.day();
  return d.subtract((dow + 6) % 7, 'day').startOf('day');
}

// 'DD/MM–DD/MM' (segunda a domingo) a partir do semana_ref.
export function fmtSemana(semanaRef: string | null | undefined): string {
  const s = isoDia(semanaRef);
  if (!s) return '—';
  const seg = dayjs(s);
  if (!seg.isValid()) return '—';
  return `${seg.format('DD/MM')}–${seg.add(6, 'day').format('DD/MM')}`;
}

// COUNT/numeric do Postgres vira STRING em node-pg: "1" + "2" = "12".
export const num = (v: number | string | null | undefined): number => {
  if (v == null) return 0;
  const n = typeof v === 'number' ? v : parseFloat(v as any);
  return isNaN(n) ? 0 : n;
};

// Nome legível a partir do e-mail, para quem não está no cadastro de
// profissionais (o backend devolve `nome` quando encontra).
export function nomeDoEmail(e: string | null | undefined): string {
  const base = String(e || '').split('@')[0].replace(/[._-]+/g, ' ').trim();
  return base ? base.replace(/\b\w/g, (c) => c.toUpperCase()) : '—';
}

export function tamanhoLegivel(bytes: number | string | null | undefined): string {
  const n = num(bytes);
  if (!n) return '—';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}
